<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="end white font-weight-bold b-right font" colspan="2">Land and
                                <br />buildings and
                                <br />leasehold improvements</td>
                            <td class="end  white font-weight-bold  b-right font">Cellular
                                <br />and other
                                <br />equipment</td>
                            <td class="end  white font-weight-bold  b-right font">Projects in
                                <br />progress</td>
                            <td class="end  white font-weight-bold font">Total</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td class="center white font-weight-bold font" colspan="2">KD ’000</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="skyBlue font" colspan="5">Cost</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="white font-weight-bold font">As at 31 December 2018</td>
                            <td class="end font white font-weight-bold font">115,571</td>
                            <td class="end font white font-weight-bold font">2,579,553</td>
                            <td class="end font white font-weight-bold font">133,371 </td>
                            <td class="end font white font-weight-bold font">2,828,495</td>
                        </tr>
                        <tr>
                            <td class="font">On acquisition of subsidiaries</td>
                            <td class="end font ">-</td>
                            <td class="end font">1,209</td>
                            <td class="end font">-</td>
                            <td class="end font">1,209</td>
                        </tr>
                        <tr>
                            <td class="font">Additions</td>
                            <td class="end font">1,319</td>
                            <td class="end font">119,660</td>
                            <td class="end font">122,338</td>
                            <td class="end font">243,317</td>
                        </tr>
                        <tr>
                            <td class="font">Transfers </td>
                            <td class="end font">836</td>
                            <td class="end font">130,460</td>
                            <td class="end font">(134,779) </td>
                            <td class="end font">(3,483)</td>
                        </tr>
                        <tr>
                            <td class="font">disposals/write off </td>
                            <td class="end font">(4,928)</td>
                            <td class="end font">(19,132)</td>
                            <td class="end font">(7,387)</td>
                            <td class="end font">(31,447)</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustment</td>
                            <td class="end font">1,318</td>
                            <td class="end font">2,065</td>
                            <td class="end font">734</td>
                            <td class="end font">4,117</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="white font-weight-bold font">As at 31 December 2019</td>
                            <td class="end font white font-weight-bold">114,116</td>
                            <td class="end font white font-weight-bold">2,813,815</td>
                            <td class="end font white font-weight-bold">114,277</td>
                            <td class="end font white font-weight-bold">3,042,208</td>
                        </tr>
                        <tr>
                            <td class="font">Additions</td>
                            <td class="end font"> 606 </td>
                            <td class="end font">138,823</td>
                            <td class="end font">172,860</td>
                            <td class="end font">312,289</td>
                        </tr>
                        <tr>
                            <td class="font">Transfers</td>
                            <td class="end font"> 778 </td>
                            <td class="end font">127,543</td>
                            <td class="end font">(128,702)</td>
                            <td class="end font">(381)</td>
                        </tr>
                        <tr>
                            <td class="font">disposals/write off </td>
                            <td class="end font">(3,435)</td>
                            <td class="end font"> (298)</td>
                            <td class="end font">(1,337)</td>
                            <td class="end font">(5,070)</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustment</td>
                            <td class="end font">(38)</td>
                            <td class="end font">(16,075)</td>
                            <td class="end font">(2,412)</td>
                            <td class="end font">(18,525)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="white font-weight-bold font">As at 31 December 2020</td>
                            <td class="end white font-weight-bold font">112,027</td>
                            <td class="end white font-weight-bold font">3,063,808</td>
                            <td class="end white font-weight-bold font">154,686</td>
                            <td class="end white font-weight-bold font">3,330,521</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">Accumulated depreciation</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2018</td>
                            <td class="end font white font-weight-bold">51,181</td>
                            <td class="end font white font-weight-bold">1,584,092</td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">1,635,273</td>
                        </tr>
                        <tr>
                            <td class="font">On acquisition of subsidiaries</td>
                            <td class="end font">-</td>
                            <td class="end font">1,153</td>
                            <td class="end font">-</td>
                            <td class="end font">1,153</td>
                        </tr>
                        <tr>
                            <td class="font">Charge for the year</td>
                            <td class="end font">3,114</td>
                            <td class="end font">196,584</td>
                            <td class="end font">- </td>
                            <td class="end font">199,698</td>
                        </tr>
                        <tr>
                            <td class="font">On disposals</td>
                            <td class="end font">(4,692)</td>
                            <td class="end font">(17,889)</td>
                            <td class="end font">-</td>
                            <td class="end font">(22,581)</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustments</td>
                            <td class="end font">185</td>
                            <td class="end font">(811)</td>
                            <td class="end font">-</td>
                            <td class="end font">(626)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2019</td>
                            <td class="end font white font-weight-bold">49,788</td>
                            <td class="end font white font-weight-bold">1,763,129</td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">1,812,917</td>
                        </tr>
                        <tr>
                            <td class="font">Charge for the year</td>
                            <td class="end font">2,806</td>
                            <td class="end font">212,177</td>
                            <td class="end font">-</td>
                            <td class="end font">214,983</td>
                        </tr>
                        <tr>
                            <td class="font">On disposals</td>
                            <td class="end font">(3,168)</td>
                            <td class="end font"> (954)</td>
                            <td class="end font">-</td>
                            <td class="end font"> (4,122)</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustments</td>
                            <td class="end font">(65)</td>
                            <td class="end font"> (6,774)</td>
                            <td class="end font">-</td>
                            <td class="end font"> (6,839)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2020</td>
                            <td class="end font white font-weight-bold"> 49,361</td>
                            <td class="end font white font-weight-bold">1,967,578</td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">2,016,939</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">Net book value</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2020</td>
                            <td class="end font white font-weight-bold">62,666</td>
                            <td class="end font white font-weight-bold">1,096,230</td>
                            <td class="end font white font-weight-bold">154,686</td>
                            <td class="end font white font-weight-bold">1,313,582</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2019</td>
                            <td class="end font white font-weight-bold">64,328</td>
                            <td class="end font white font-weight-bold">1,050,686</td>
                            <td class="end font white font-weight-bold">114,277</td>
                            <td class="end font white font-weight-bold">1,229,291</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="end white font-weight-bold b-right font" colspan="2">أرض ومباني
                                <br />وتحسينات على 
                                <br />مباني مستأجرة</td>
                            <td class="end  white font-weight-bold  b-right font">شبكات خلوية
                                <br />ومعدات أخرى</td>
                            <td class="end  white font-weight-bold  b-right font">مشاريع
                                <br />قيد التنفيذ‍</td>
                            <td class="end  white font-weight-bold font">المجموع</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td class="center white font-weight-bold font" colspan="2">ألف دينار كويتي</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="skyBlue font" colspan="5">التكلفة</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="white font-weight-bold font">كما في 31 ديسمبر 2018</td>
                            <td class="end font white font-weight-bold font">115,571</td>
                            <td class="end font white font-weight-bold font">2,579,553</td>
                            <td class="end font white font-weight-bold font">133,371 </td>
                            <td class="end font white font-weight-bold font">2,828,495</td>
                        </tr>
                        <tr>
                            <td class="font">نتيجة الاستحواذ على شركات زميلة</td>
                            <td class="end font ">-</td>
                            <td class="end font">1,209</td>
                            <td class="end font">-</td>
                            <td class="end font">1,209</td>
                        </tr>
                        <tr>
                            <td class="font">إضافات</td>
                            <td class="end font">1,319</td>
                            <td class="end font">119,660</td>
                            <td class="end font">122,338</td>
                            <td class="end font">243,317</td>
                        </tr>
                        <tr>
                            <td class="font">تحويلات</td>
                            <td class="end font">836</td>
                            <td class="end font">130,460</td>
                            <td class="end font">(134,779) </td>
                            <td class="end font">(3,483)</td>
                        </tr>
                        <tr>
                            <td class="font">استبعادات / مشطوبات</td>
                            <td class="end font">(4,928)</td>
                            <td class="end font">(19,132)</td>
                            <td class="end font">(7,387)</td>
                            <td class="end font">(31,447)</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">1,318</td>
                            <td class="end font">2,065</td>
                            <td class="end font">734</td>
                            <td class="end font">4,117</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="white font-weight-bold font">كما في 31 ديسمبر 2019</td>
                            <td class="end font white font-weight-bold">114,116</td>
                            <td class="end font white font-weight-bold">2,813,815</td>
                            <td class="end font white font-weight-bold">114,277</td>
                            <td class="end font white font-weight-bold">3,042,208</td>
                        </tr>
                        <tr>
                            <td class="font">إضافات</td>
                            <td class="end font"> 606 </td>
                            <td class="end font">138,823</td>
                            <td class="end font">172,860</td>
                            <td class="end font">312,289</td>
                        </tr>
                        <tr>
                            <td class="font">تحويلات</td>
                            <td class="end font"> 778 </td>
                            <td class="end font">127,543</td>
                            <td class="end font">(128,702)</td>
                            <td class="end font">(381)</td>
                        </tr>
                        <tr>
                            <td class="font">استبعادات / مشطوبات</td>
                            <td class="end font">(3,435)</td>
                            <td class="end font"> (298)</td>
                            <td class="end font">(1,337)</td>
                            <td class="end font">(5,070)</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">(38)</td>
                            <td class="end font">(16,075)</td>
                            <td class="end font">(2,412)</td>
                            <td class="end font">(18,525)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="white font-weight-bold font">كما في 31 ديسمبر 2020</td>
                            <td class="end white font-weight-bold font">112,027</td>
                            <td class="end white font-weight-bold font">3,063,808</td>
                            <td class="end white font-weight-bold font">154,686</td>
                            <td class="end white font-weight-bold font">3,330,521</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">الاستهلاكات المتراكمة</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2018</td>
                            <td class="end font white font-weight-bold">51,181</td>
                            <td class="end font white font-weight-bold">1,584,092</td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">1,635,273</td>
                        </tr>
                        <tr>
                            <td class="font">نتيجة الاستحواذ على شركات تابعة</td>
                            <td class="end font">-</td>
                            <td class="end font">1,153</td>
                            <td class="end font">-</td>
                            <td class="end font">1,153</td>
                        </tr>
                        <tr>
                            <td class="font">المحمل على السنة</td>
                            <td class="end font">3,114</td>
                            <td class="end font">196,584</td>
                            <td class="end font">- </td>
                            <td class="end font">199,698</td>
                        </tr>
                        <tr>
                            <td class="font">نتيجة الاستبعادات</td>
                            <td class="end font">(4,692)</td>
                            <td class="end font">(17,889)</td>
                            <td class="end font">-</td>
                            <td class="end font">(22,581)</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">185</td>
                            <td class="end font">(811)</td>
                            <td class="end font">-</td>
                            <td class="end font">(626)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2019</td>
                            <td class="end font white font-weight-bold">49,788</td>
                            <td class="end font white font-weight-bold">1,763,129</td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">1,812,917</td>
                        </tr>
                        <tr>
                            <td class="font">المحمل على السنة</td>
                            <td class="end font">2,806</td>
                            <td class="end font">212,177</td>
                            <td class="end font">-</td>
                            <td class="end font">214,983</td>
                        </tr>
                        <tr>
                            <td class="font">نتيجة الاستبعادات</td>
                            <td class="end font">(3,168)</td>
                            <td class="end font"> (954)</td>
                            <td class="end font">-</td>
                            <td class="end font"> (4,122)</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">(65)</td>
                            <td class="end font"> (6,774)</td>
                            <td class="end font">-</td>
                            <td class="end font"> (6,839)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2020</td>
                            <td class="end font white font-weight-bold"> 49,361</td>
                            <td class="end font white font-weight-bold">1,967,578</td>
                            <td class="end font white font-weight-bold">-</td>
                            <td class="end font white font-weight-bold">2,016,939</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">صافي القيمة الدفترية</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2020</td>
                            <td class="end font white font-weight-bold">62,666</td>
                            <td class="end font white font-weight-bold">1,096,230</td>
                            <td class="end font white font-weight-bold">154,686</td>
                            <td class="end font white font-weight-bold">1,313,582</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2019</td>
                            <td class="end font white font-weight-bold">64,328</td>
                            <td class="end font white font-weight-bold">1,050,686</td>
                            <td class="end font white font-weight-bold">114,277</td>
                            <td class="end font white font-weight-bold">1,229,291</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>